import { render } from "./PlaceModal.vue?vue&type=template&id=042206cf&scoped=true&ts=true"
import script from "./PlaceModal.vue?vue&type=script&lang=ts"
export * from "./PlaceModal.vue?vue&type=script&lang=ts"

import "./PlaceModal.vue?vue&type=style&index=0&id=042206cf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042206cf"]])

export default __exports__